import {CompetitionViewModel} from "../../../domain/common/competition/models/competition-view-model";
import {computed, observable} from "mobx";
import {GameCardViewModel} from "../../../core/components/game-card/view-models/game-card.view-model";
import {AppTerms} from "../../../core/app/app-terms";
import {CompetitionGamesDomainModel} from "../../../domain/common/competition-games.domain-model";
import {StandingsListAssetsRequestParams} from "../../my-scores-widget/components/assets/standings-list-assets-request.params";
import {StandingsLiveListAssetsRequestParams} from "../../my-scores-widget/components/assets/standings-live-list-assets.request-params";

export class CompetitionGamesViewModel extends CompetitionViewModel {
  competitionGamesModel: CompetitionGamesDomainModel;
  @observable games: Array<GameCardViewModel>;
  terms: AppTerms;
  isSmallView: Boolean;
  isSelected: Boolean;
  isMajor: Boolean;

  constructor(domain: CompetitionGamesDomainModel, games: Array<GameCardViewModel>, terms: AppTerms, isSmallView: Boolean) {
    super(domain);

    this.competitionGamesModel = domain;
    this.isSelected = false;
    this.isMajor = false;
    this.terms = terms;
    this.isSmallView = isSmallView;
    this.games = games;
  }

  @computed get liveGamesCount(): Number {
    return this.competitionGamesModel.liveGamesCount;
  }

  get objectType(): String {
    return CompetitionViewModel.name;
  }


  @computed get standingsIcon(): StandingsListAssetsRequestParams {
    const icon = this.competitionGamesModel.hasLiveStandings ? new StandingsLiveListAssetsRequestParams(24) : new StandingsListAssetsRequestParams(24);
    return icon;
  }
}
